module.exports = __webpack_public_path__ + "static/media/right-chevron.b5df0e7a.svg";